import React from 'react';
import { InputMeta, InputWrapper, ModifiedInput } from '.';
import './InputSwitch.scss';
import cn from 'classnames';

interface InputRadioProps extends Omit<ModifiedInput, 'value'> {
  onChange: (value: string | boolean) => void;
  options: {
    label: string | React.ReactNode;
    value: string | boolean;
  }[];
  meta?: InputMeta;
  value?: string | boolean;
}

export const InputSwitch: React.FC<InputRadioProps> = ({
  options,
  onChange,
  id,
  name,
  value,
  className,
  meta,
  ...unused
}) => {
  return (
    <InputWrapper {...meta}>
      <div className={cn('input-switch', 'flex', 'w-full', className)} {...unused}>
        {options.map((option, i) => {
          return (
            <React.Fragment key={i}>
              <input
                id={`${id}_${i}`}
                type={'radio'}
                name={name}
                onChange={() => onChange(option.value)}
                checked={value === option.value}
                value={String(option.value)}
              />
              <label htmlFor={`${id}_${i}`}>{option.label}</label>
            </React.Fragment>
          );
        })}
      </div>
    </InputWrapper>
  );
};
